/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum AuditEventSource {
    DirectoryAudit = 'DirectoryAudit',
    SignIn = 'SignIn'
}


export function instanceOfAuditEventSource(value: any): boolean {
    for (const key in AuditEventSource) {
        if (Object.prototype.hasOwnProperty.call(AuditEventSource, key)) {
            if (AuditEventSource[key as keyof typeof AuditEventSource] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AuditEventSourceFromJSON(json: any): AuditEventSource {
    return AuditEventSourceFromJSONTyped(json, false);
}

export function AuditEventSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuditEventSource {
    return json as AuditEventSource;
}

export function AuditEventSourceToJSON(value?: AuditEventSource | null): any {
    return value as any;
}

export function AuditEventSourceToJSONTyped(value: any, ignoreDiscriminator: boolean): AuditEventSource {
    return value as AuditEventSource;
}

